import logo from '../assets/logo.png';
import searchIcon from '../assets/поиск.png';
import favoritesIcon from '../assets/избранное.png';
import cartIcon from '../assets/корзина.png';
import profileIcon from '../assets/профиль.png';
import catalogIcon from '../assets/catalog-icon.svg';

interface HeaderProps {
  isCatalogOpen?: boolean;
  onCatalogToggle?: () => void;
  onLogoClick?: () => void;
  onFavoritesClick?: () => void;
  onCartClick?: () => void;
  onProfileClick?: () => void;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  onSearchSubmit?: () => void;
}

export default function Header({
  isCatalogOpen = false,
  onCatalogToggle,
  onLogoClick,
  onFavoritesClick,
  onCartClick,
  onProfileClick,
  searchValue = '',
  onSearchChange,
  onSearchSubmit,
}: HeaderProps) {
  return (
    <header className="relative z-50 mx-auto w-full max-w-[1520px] px-2.5 sm:px-5 lg:px-8">
      <div className="rounded-b-[20px] bg-white px-2.5 py-2.5 shadow-[0_8px_18px_rgba(0,0,0,0.04)] sm:px-5 sm:py-4 lg:px-8">
        <div className="grid grid-cols-[auto_1fr] items-center gap-2.5 sm:gap-4 lg:flex lg:flex-nowrap lg:items-center lg:gap-5">
          <button
            type="button"
            onClick={onLogoClick}
            className="h-[38px] w-[50px] flex-shrink-0 transition-opacity duration-200 hover:opacity-80 sm:h-[66px] sm:w-[92px]"
          >
            <img src={logo} alt="Ксюник" className="h-full w-full object-contain" />
          </button>

          <div className="flex min-w-0 items-center justify-end gap-2 sm:gap-3 lg:order-4 lg:ml-auto">
            <button
              type="button"
              onClick={onFavoritesClick}
              className="relative h-[50px] w-[50px] flex-shrink-0 transition-transform duration-150 hover:scale-[1.04] active:scale-95 sm:h-[48px] sm:w-[48px] lg:h-[50px] lg:w-[50px]"
            >
              <img src={favoritesIcon} alt="Избранное" className="h-full w-full object-contain" />
            </button>

            <button
              type="button"
              onClick={onCartClick}
              className="relative h-[50px] w-[50px] flex-shrink-0 transition-transform duration-150 hover:scale-[1.04] active:scale-95 sm:h-[48px] sm:w-[48px] lg:h-[50px] lg:w-[50px]"
            >
              <img src={cartIcon} alt="Корзина" className="h-full w-full object-contain" />
            </button>

            <button
              type="button"
              onClick={onProfileClick}
              className="relative h-[50px] w-[50px] flex-shrink-0 transition-transform duration-150 hover:scale-[1.04] active:scale-95 sm:h-[48px] sm:w-[48px] lg:h-[50px] lg:w-[50px]"
            >
              <img src={profileIcon} alt="Профиль" className="h-full w-full object-contain" />
            </button>
          </div>

          <div className="col-span-2 order-3 flex min-w-0 items-center gap-2 lg:order-2 lg:col-span-1 lg:flex-1 lg:gap-5">
            <div className="flex h-[54px] min-w-0 flex-1 items-center overflow-hidden rounded-[20px] border-[3px] border-[#5d76cb] bg-white shadow-[0_0_10px_0_#6c63ff55] transition-all duration-200 focus-within:border-[#4d66bb] focus-within:shadow-[0_0_14px_0_#6c63ff66] sm:h-[52px] lg:h-[50px] lg:rounded-[18px]">
              <input
                type="text"
                value={searchValue}
                onChange={(e) => onSearchChange?.(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    onSearchSubmit?.();
                  }
                }}
                placeholder="Ищите товар по названию или артикулу..."
                className="h-full min-w-0 flex-1 border-0 bg-transparent px-4 text-[14px] font-light tracking-[0.2px] text-[#6f6f6f] outline-none placeholder:text-[#8b8b8b] sm:px-4 sm:text-[16px] lg:text-[15px]"
              />
              <button
                type="button"
                onClick={onSearchSubmit}
                className="flex h-full w-[50px] flex-shrink-0 items-center justify-center border-l border-[#5d76cb] transition-colors duration-200 hover:bg-[#f7f9ff] sm:w-[58px]"
              >
                <img src={searchIcon} alt="Поиск" className="h-[20px] w-[20px] object-contain sm:h-[22px] sm:w-[22px]" />
              </button>
            </div>

            <button
              type="button"
              onClick={onCatalogToggle}
              className="flex h-[48px] w-[48px] min-w-[48px] flex-shrink-0 items-center justify-center rounded-[17px] border border-[#d7e0ff] bg-[#f6f8ff] shadow-[0_4px_12px_rgba(93,118,203,0.12)] transition-all duration-100 hover:bg-[#edf2ff] active:scale-[0.99] sm:h-[52px] sm:min-w-[176px] sm:rounded-[16px] sm:border-0 sm:bg-[#5d76cb] sm:px-4 sm:shadow-[1px_1px_5px_0px_rgba(0,0,0,0.25)] sm:hover:bg-[#4d66bb] lg:h-[50px] lg:w-[190px]"
              aria-label="Открыть каталог"
            >
              <span className="hidden flex-1 text-center text-[20px] font-bold text-white sm:block">Каталог</span>
              {isCatalogOpen ? (
                <div className="relative h-[18px] w-[18px] flex-shrink-0">
                  <span className="absolute left-1/2 top-1/2 h-[2.5px] w-[16px] -translate-x-1/2 -translate-y-1/2 rotate-45 rounded-full bg-[#4d66bb] sm:bg-white" />
                  <span className="absolute left-1/2 top-1/2 h-[2.5px] w-[16px] -translate-x-1/2 -translate-y-1/2 -rotate-45 rounded-full bg-[#4d66bb] sm:bg-white" />
                </div>
              ) : (
                <img src={catalogIcon} alt="" className="h-[20px] w-[15px] flex-shrink-0 sm:h-[30px] sm:w-[22px]" />
              )}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
